import React, { Component } from "react";
import "../css/App.css";

class AssignedModulesParentComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }
  componentWillMount() {}

  render() {
    return (
      <div
        className="area col-md-12"
        onClick={() => this.props.Onpress()}
        style={{ cursor: "pointer" }}
      >
        <h4
          className="text-white mZero"
          style={{
            textTransform: "capitalize",
            fontSize: "14px",
            letterSpacing: ".5px",
            fontWeight: "500",
          }}
        >
          {this.props.ParentComponentTitle}
        </h4>
        <span className="align-item-center" style={{ display: "flex", }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              className="topic"
              style={{ fontSize: "12px", fontWeight: "400" }}
            >
              {this.props.UnitsCount} Unit(s)
            </span>
            {/* Completion Status Tick Icon */}
            {this.props.completed && (
              <div
                style={{
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  backgroundColor: this.props.completed || "#7ed321",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "8px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
                }}
              >
                <i
                  className="material-icons"
                  style={{
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold"
                  }}
                >
                  check
                </i>
              </div>
            )}
          </div>
          <div>
            {this.props.ui_open === true ? (
              <i className="material-icons">keyboard_arrow_down</i>
            ) : (
              <i className="material-icons">keyboard_arrow_right</i>
            )}
          </div>
        </span>
      </div>
    );
  }
}

export default AssignedModulesParentComponent;
